module.exports = __webpack_public_path__ + "img/video_placeholder.044ceb15.jpg";